import Backbone from 'backbone'

import store from '../../store'
import { GoodsModel } from '../../store/goods.model'
import {
  getSelectedGoods,
  resetSelectedGoods,
} from '../../manager/collection.controller'

export var EmoticonCollection = Backbone.Collection.extend({
  model: GoodsModel,
  getSelectedGoods: getSelectedGoods,
  resetSelectedGoods: resetSelectedGoods,
  sync: function (method, model, options) {
    if (method === 'read') {
      options.success(store.list.get('emoticon'))
    }
  },
})
